import i18next, { i18n, Resource } from 'i18next';

type GetI18nInstanceType = (
  resources: Resource,
) => Promise<{ i18n: i18n; i18nResources: Resource }>;

export const getI18nInstance: GetI18nInstanceType = async (
  messages: Resource,
) => {
  const resources = {
    en: {
      translation: messages,
    },
  };

  await i18next.init({
    lng: 'en',
    resources,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

  return {
    i18n: i18next,
    i18nResources: resources,
  };
};
